import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import Fa from 'react-fontawesome';
import Joi from 'joi';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import DateTimeDisplay from '../../../../components/date-time-display';
import { getFeedbackRequestSettings } from '../../../Dashboard/DashboardReducer';


class ExcludeOpportunityForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      including: false,
    };
    this.close = this.close.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.includeOpportunity = this.includeOpportunity.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      const { opportunity } = nextProps;
      const params = { reason_id: null, reason: null };
      if (opportunity) {
        if (opportunity.exclusion?.reason_id && opportunity.exclusion?.reason_id !== 'CONTACT' && opportunity.exclusion?.reason_id !== 'OTHER') {
          params.reason_id = opportunity.exclusion?.reason_id;
        }
        if (opportunity.exclusion?.reason) {
          params.reason = opportunity.exclusion?.reason;
        }  
      }
      this.props.initialize(params);
    }
  }

  close() {
    this.props.onClose(this.props.opportunity);
  }

  cancel() {
    this.props.onCancel(this.props.opportunity);
  }

  handleSubmit(data) {
    const p = this.props.requestExclude(this.props.opportunity, data);
    return p.then(
      (r) => {
        this.props.onClose(this.props.opportunity);
      },
      (errors) => {
        const e = errors.data || errors;
        if (e.message) {
          e._error = e.message;
        }
        throw new SubmissionError(e);
      },
    );
  }

  includeOpportunity() {
    return new Promise((resolve, reject) => {
      if (this.state.including) {
        return reject(new Error('updating'));
      }
      this.setState({ including: true });
      const p = this.props.requestInclude(this.props.opportunity);
      p.then(
        (r) => {
          this.setState({ including: false });
          resolve(r);
        },
        (e) => {
          this.setState({ including: false });
          reject(e);
        },
      );
    });
  }

  renderField({
    input, label, componentClass, placeholder, options, className, meta: { touched, error },
  }) {
    const { submitting } = this.props;

    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup className={className} validationState={validationState}>
        {label !== null && label !== undefined && <ControlLabel>{label}</ControlLabel>}
        {componentClass !== 'select' &&
          <FormControl
            {...input}
            componentClass={componentClass}
            placeholder={placeholder}
            disabled={submitting}
          />
        }
        {componentClass === 'select' &&
          <FormControl
            {...input}
            componentClass={componentClass}
            disabled={submitting}
          >
            <option value="">please select an exclusion reason</option>
            {options.map(o => (<option key={o._id} value={o._id}>{o.label}</option>))}
          </FormControl>
        }
        {error && touched && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderForm() {
    const {
      handleSubmit, submitting, valid,
      isModal, opportunity,
      isAccount, reasons,
      selectReasonId, otherReasonId,
      error,
    } = this.props;
    if (!reasons || reasons.length === 0) {
      return (
        <div>
          <Modal.Body>
            <div className="alert alert-danger">No exclusion reasons found.</div>
          </Modal.Body>
          <Modal.Footer>
            <div className="clearfix">
              {isModal &&
                <Button className="pull-left" bsStyle="link" disabled={submitting} onClick={this.close}>Cancel</Button>
              }
              {!isModal &&
                <Button className="pull-left" bsStyle="link" disabled={submitting} onClick={this.cancel}>Cancel</Button>
              }
            </div>
          </Modal.Footer>
        </div>
      );
    }


    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Modal.Body>
          {!isModal &&
            <div className="text-warning">
              <Fa name="exclamation-triangle" /> Please provide the reason to exclude <strong>{opportunity.name}</strong> from feedback requests:
              <p />
            </div>
          }

          {error && <div className="alert alert-danger">{error}</div>}

          <Field
            name="reason_id"
            label="Exclude Reason:"
            componentClass="select"
            options={reasons}
            component={this.renderField}
          />



          {otherReasonId !== null && otherReasonId === selectReasonId &&
            <Field
              name="reason"
              placeholder="Please provide exclusion reason:"
              componentClass="textarea"
              component={this.renderField}
            />
          }


        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            {isModal &&
              <Button className="pull-left" bsStyle="link" disabled={submitting} onClick={this.close}>Do not exclude</Button>
            }
            {!isModal &&
              <Button className="pull-left" bsStyle="link" disabled={submitting} onClick={this.cancel}>Cancel</Button>
            }
            <Button className="pull-right" bsStyle="danger" disabled={submitting || !valid} type="submit">
              {!submitting && <span>Exclude {isAccount ? 'Account' : 'Opportunity'}</span>}
              {submitting && <span><Fa name="spinner" spin /></span>}
            </Button>
          </div>
        </Modal.Footer>
      </form>
    );
  }

  renderModal() {
    const {
      show, opportunity,
    } = this.props;
    return (
      <Modal show={show} onExited={this.close}>
        <Modal.Header>
          <Modal.Title>Exclude <strong>{opportunity.name}</strong> from feedback requests</Modal.Title>
        </Modal.Header>
        {this.renderForm()}
      </Modal>
    );
  }

  renderExcludeMessage() {
    const { including } = this.state;
    const { opportunity, auth, isAccount } = this.props;
    if (!opportunity.exclusion) {
      return null;
    }
    let name = null;
    if (opportunity.exclusion.user) {
      name = opportunity.exclusion.user.display_name;
    }
    if (opportunity.exclusion.user__id === auth._id) {
      name = 'You';
    }
    const date = opportunity.exclusion.created_at;
    const suffix = (
      <span>from requesting feedback <DateTimeDisplay maxRelativeDifferentDays={7} relative value={date} format="shortWithTime" /></span>
    );
    let reasonComp = null;
    if (opportunity.exclusion.reason) {
      reasonComp = (<span>with the following reason: {opportunity.exclusion.reason}</span>);
    }

    
    let comp = (
      <span>This {isAccount ? 'account' : 'deal'} was excluded {suffix}</span>
    );
    if (name) {
      comp = (<span><strong>{name}</strong> excluded this {isAccount ? 'account' : 'deal'} {suffix}</span>);
      if (opportunity.exclusion.reason) {
        reasonComp = (<span>and provided the following reason: {opportunity.exclusion.reason}</span>);
      }
    }
    return (
      <div key="exclude">
        <div className="alert alert-warning" style={{ margin: 0 }}>
          <div className="clearfix">
            <div className="pull-right">
              &nbsp;&nbsp;
              <Button disabled={including} bsStyle="default" onClick={this.includeOpportunity} bsSize="xs">
                {!including && <span>Undo</span>}
                {including && <span><Fa name="spinner" spin /> Updating</span>}
              </Button>
            </div>
            <div>
              <Fa name="exclamation-triangle" /> {comp} {reasonComp}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      isModal, opportunity,
    } = this.props;
    if (!opportunity) {
      return null;
    }
    if (isModal) {
      return this.renderModal();
    }
    if (opportunity.exclusion) {
      return this.renderExcludeMessage();
    }
    return this.renderForm();
  }
}

ExcludeOpportunityForm.propTypes = {
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  valid: PropTypes.bool.isRequired,
  error: PropTypes.string,
  opportunity: PropTypes.shape({
    name: PropTypes.string,
    exclusion: PropTypes.shape({
      reason_id: PropTypes.string,
      reason: PropTypes.string,
      user__id: PropTypes.string,
      created_at: PropTypes.string,
      user: PropTypes.shape({
        display_name: PropTypes.string,
      }),
    }),
  }),
  requestExclude: PropTypes.func,
  requestInclude: PropTypes.func,
  onCancel: PropTypes.func,
  isModal: PropTypes.bool,
  auth: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  isAccount: PropTypes.bool,
  reasons: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
  })),
  selectReasonId: PropTypes.string,
  otherReasonId: PropTypes.string,
};
ExcludeOpportunityForm.defaultProps = {
  show: false,
  onClose: () => {},
  onCancel: () => {},
  requestExclude: () => {},
  requestInclude: () => {},
  isModal: true,
  opportunity: null,
  isAccount: false,
  reasons: [],
  selectReasonId: null,
  otherReasonId: null,
  error: null,
};

const validate = (data, props) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   reason_id: {
  //     type: 'string',
  //     presence: { allowEmpty: false },
  //   },
  //   ...(props.otherReasonId && props.otherReasonId === props.selectReasonId ? {
  //     reason: {
  //       presence: { allowEmpty: false },
  //       length: {
  //         minimum: 10,
  //         maximum: 2048,
  //       },
  //     },
  //   } : {}),
  // };

  const schemaFields = {
    reason_id: Joi.string().required().messages({
      'string.base': 'Reason is required',
      'string.empty': 'Reason is required',
      'any.required': 'Reason is required',
    }),
  };

  if (props.otherReasonId && props.otherReasonId === props.selectReasonId) {
    schemaFields.reason = Joi.string().min(10).max(2048).required().messages({
      'string.base': 'Other reason must be a string',
      'string.empty': 'Other reason is required',
      'any.required': 'Other reason is required',
      'string.min': 'Other reason must be at least 10 characters',
      'string.max': 'Other reason must be at most 2048 characters',
    });
  }

  const schema = Joi.object(schemaFields).unknown(true);
  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const selector = formValueSelector('excludeOpportunityForm');

function mapStateToProps(state) {
  const feedbackRequestSettings = getFeedbackRequestSettings(state);
  const reasons = feedbackRequestSettings?.exclusion_reasons || [];

  const otherReason = find(reasons, { type: 'OTHER' });
  const otherReasonId = otherReason ? otherReason._id : null;

  return {
    reasons,
    selectReasonId: selector(state, 'reason_id'),
    otherReasonId,
  };
}
const ExcludeModalForm = reduxForm({
  form: 'excludeOpportunityForm',
  validate,
})(ExcludeOpportunityForm);

export default connect(mapStateToProps)(ExcludeModalForm);
